import { render, staticRenderFns } from "./EnderecoConjugue.vue?vue&type=template&id=13119b2f&"
import script from "./EnderecoConjugue.vue?vue&type=script&lang=js&"
export * from "./EnderecoConjugue.vue?vue&type=script&lang=js&"
import style0 from "./EnderecoConjugue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports